import { render, staticRenderFns } from "./OptnList.vue?vue&type=template&id=69ee218b&scoped=true&"
import script from "./OptnList.vue?vue&type=script&lang=js&"
export * from "./OptnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ee218b",
  null
  
)

export default component.exports